<template>
  <div class="chongzhi">
    <van-nav-bar fixed placeholder title="帐号充值" left-arrow @click-left="$router.back()">
    </van-nav-bar>
    <van-form @submit="onSubmit" class="chongzhiform">
      <div v-if="productType!='1'">
        <div class="chongzhitip"> VIP充值/缴费 充值后自动开通</div>
        <van-radio-group v-model="radio">
          <ul class="functionlist">
            <li v-for="(product,index) in productList" :key="index" style="margin-top:0;">
              <div class="productitem">
                <div class="title" style="width:60%;">{{ product.productName }}</div>
                <div style="width:30%;">￥{{ product.price }}</div>
                <div class="xuanze">
                  <van-radio :name="product.id" icon-size="24px"></van-radio>
                </div>
              </div>
            </li>
          </ul>
        </van-radio-group>
      </div>
      <div v-if="productType=='1'">
        <ul class="flex jifenbuylist f-12">
          <li v-for="(product,index) in productList" :key="index" :class="radio==product.id?'active':''"
              @click="radio=product.id">
            <div><span class="lr">充值</span><span class="pricedesc m-l-20 m-r-20 f-28">{{ product.price }}</span>元</div>
            <!-- <div class="desc">{{(product.days-product.price*10)>0?'赠送'+(product.days-product.price*10)+'积分':'1元等于10积分'}}</div> -->
            <div class="desc">
              0.4元等于10积分<br/>{{
                ((product.days - (product.price * 10 / 0.4)) > 0) ? '赠送了' + (product.days - product.price * 10 / 0.4) + '积分' : ''
              }}
            </div>
            <div><span class="fen">{{ product.days }}</span>积分</div>
          </li>
          <!-- <li :class="radio=='2'?'active':''" @click="radio='2'">
            <div><span class="lr">充值</span><span class="fen">310</span>积分</div>
            <div class="desc">赠送10积分</div>
            <div class="pricedesc">￥<span>30.00</span></div>
          </li>
          <li :class="radio=='3'?'active':''" @click="radio='3'">
            <div><span class="lr">充值</span><span class="fen">550</span>积分</div>
            <div class="desc">赠送50积分</div>
            <div class="pricedesc">￥<span>50.00</span></div>
          </li> -->
        </ul>
        <div class="ta-c m-b--35 m-t-30 f-12">此积分只能使用在案例读取，不能用在资料读取。</div>
      </div>
      <div style="margin: 16px; margin-top:50px">
        <van-button class="f-16" round block type="info" native-type="submit">
          购买
        </van-button>
        <div class="m-t-10 f-12"> 港澳台地区，请联系客服</div>
      </div>
    </van-form>
    <van-popup closeable close-icon="close" v-model="show" position="bottom" :style="{ height: '50%' }">
      <van-row style="background:#CCC; height:50px; line-height:50px;">
        <van-col span="24">确认订单</van-col>
      </van-row>
      <van-row style="height:50px; line-height:50px; text-align:left; padding-left:20px">
        <van-col span="20">{{ currentProduct.productName }}</van-col>
        <van-col span="4">￥{{ currentProduct.price }}</van-col>
      </van-row>
      <van-cell-group>
        <van-radio-group v-model="payType">
          <van-cell size="large" title-style="text-align:left;" class="f-16 p-10" clickable @click="payType = '微信'">
            <template #title>
              <span class="custom-title f-16 m-l-20">微信支付</span>
            </template>
            <template #icon="">
              <van-icon class="iconfont m-10" class-prefix="icon" name="weixinzhifu" size="36px" color="#40ba49"/>
            </template>
            <template #right-icon>
              <van-radio name="微信"/>
            </template>
          </van-cell>
          <!-- <van-cell size="large" title-style="text-align:left;" class="f-16" clickable @click="payType = '5'">
            <template #title>
              <span class="custom-title f-16 m-l-20">微信支付</span>
            </template>
            <template #icon>
              <van-icon class="iconfont m-10" class-prefix="icon" name="zhifubao" size="36px" color="#009fe8" />
            </template>
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell> -->
        </van-radio-group>
      </van-cell-group>
      <van-submit-bar :safe-area-inset-bottom="!isWxBrowser()" :price="currentProduct.price*100" button-text="提交订单"
                      @submit="callpay"/>
    </van-popup>
  </div>
</template>

<script>
import {
  Col,
  Row,
  Image as VanImage,
  Icon,
  Cell,
  CellGroup,
  Tag,
  NavBar,
  Form,
  RadioGroup,
  Radio,
  Button,
  Popup,
  SubmitBar,
  Toast,
  Dialog, Notify,
} from "vant";
import MainMenuNav from "@/components/MainMenuNav.vue";
import {
  Get_Product_List,
  H5Pay,
  JsApi,
  Check_pay,
  Check_Wx_Login,
  Check_Wx_OpenID,
  Get_Wx_OpenID,
} from "@/api/index";

export default {
  name: "UserProduct",
  components: {
    MainMenuNav,
    [Col.name]: Col,
    [Row.name]: Row,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [SubmitBar.name]: SubmitBar,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      user: this.global.getUserInfo(),
      company: this.global.getMemberSystem(),
      payType: "微信",
      show: false,
      productList: [],
      currentProduct: {},
      payParams: {},
      radio: "",
      productType: this.global.isNull(this.$route.query.productType) ? 700 : 1, //700是维修资料  1是积分
    };
  },
  methods: {
    //判断是否在微信浏览器内
    isWxBrowser: function () {
      let ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    isIPhone() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.includes('iphone')
    },
    onSubmit: function (values) {
      if (this.isWxBrowser() && !this.isIPhone()) {
        this.$router.push({path: "/jumpmp", "query": {"fr": "pay"}})
      } else {
        this.show = true;
        this.currentProduct = this.productList.find((item) => {
          return item.id == this.radio;
        });
      }
      // this.callpay();
      // Notify({message: "请到小程序支付", type: "warning"});
    },
    jsApiCall: function () {
      let that = this;
      Toast.loading({
        message: "支付中...",
        duration: 0,
        forbidClick: true,
        overlay: true,
      });
      WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          // {
          //   appId: this.payParams.appId, //公众号名称，由商户传入
          //   timeStamp: this.payParams.timeStamp, //时间戳
          //   nonceStr: this.payParams.nonceStr, //随机串
          //   package: this.payParams.package, //扩展包
          //   signType: this.payParams.signType, //微信签名方式:MD5
          //   paySign: this.payParams.paySign //微信签名
          // },
          this.payParams,
          function (res) {
            Toast.clear();
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              Toast.success({
                message: "支付成功",
                forbidClick: true,
                overlay: true,
                onClose: function () {
                  window.location.href = "/";
                  this.$router.push({path: "/"});
                },
              });
            }
          }
      );
    },
    callpay: function () {
      if (!this.isWxBrowser()) {
        let wPath = window.document.location.href;
        // 获取当前页面主机地址之后的目录，如：/admin/index
        let pathName = this.$route.path;
        let pos = wPath.indexOf(pathName);
        // 获取主机地址，如：http://localhost:8080
        let localhostPath = wPath.substring(0, pos);

        H5Pay({productId: this.radio, payId: this.payType, returnUrl: localhostPath}).then((data) => {
          console.log("H5支付请求", data)
          // data = {
          //   "timeStamp": "1648289417575",
          //     "nonceStr": "DTOkBkVgYsKyAL9r",
          //     "prepayId": "wx261810175461351a1756344893b7dc0000",
          //     "signType": "MD5",
          //     "paySign": "CDE113EB6FA8EC0A69B411C1840F41D7",
          //     "codeURL": null,
          //     "mwebUrl": "https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx261810175461351a1756344893b7dc0000&package=3182640242&redirect_url=http://www.carziliao.com",
          //     "amount": 9900
          // }
          window.location.href = data.mwebUrl;
        });
      } else {
        this.$router.push({path: "/jumpmp"})
        //Check_Wx_Login判断一下，直接跳转，临时解决微信授权的跨域问题
        // Check_Wx_Login().then((data) => {
        //   if (data) {
        //     JsApi({productId: this.radio, payId: this.payType}).then((data) => {
        //       this.payParams = data;
        //       if (typeof WeixinJSBridge == "undefined") {
        //         if (document.addEventListener) {
        //           document.addEventListener(
        //               "WeixinJSBridgeReady",
        //               this.jsApiCall(),
        //               false
        //           );
        //         } else if (document.attachEvent) {
        //           document.attachEvent("WeixinJSBridgeReady", this.jsApiCall());
        //           document.attachEvent("onWeixinJSBridgeReady", this.jsApiCall());
        //         }
        //       } else {
        //         this.jsApiCall();
        //       }
        //     });
        //   } else {
        //     window.location.href =
        //         this.global.APIBasePath +
        //         "/Pay/JsApi?productId=" +
        //         this.radio +
        //         "&payId=" +
        //         this.payType;
        //   }
        // });
      }
    },
  },
  async mounted() {
    this.global.getMemberSystem().then((company) => {
      if (company.isCanPay == 0) {
        Dialog.alert({
          message: "请联系客服",
        }).then(() => {
          this.$router.push({path: "/"});
        });
      }
    });
    // if (this.isWxBrowser()) {
    //   await Check_Wx_OpenID().then((data) => {
    //     if (!data) {
    //       window.location.href = this.global.APIBasePath + "/User/GetWxOpenID";
    //     }
    //   });
    // }

    Get_Product_List({type: this.productType}).then((data) => {
      this.productList = [data || {}];
      this.radio = this.productList[0].id;
    });
  }
  ,
}
;
</script>
